import { render, staticRenderFns } from "./ClientType.vue?vue&type=template&id=67ddc3a3"
import script from "./ClientType.vue?vue&type=script&lang=js"
export * from "./ClientType.vue?vue&type=script&lang=js"
import style0 from "./ClientType.vue?vue&type=style&index=0&id=67ddc3a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports